import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, submitReport } from "./actions";
import { cellStyle } from "../gridHelper";
import {
    Card,
    CardHeader,
    CardContent,
    Typography,
    TextField,
    Select,
    MenuItem,
    Button
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { selectVehicleChecklist } from "./selectors";
import ReactToPrint from "react-to-print";
import { noSig } from "vrcore-dashboard/dist/utilities";

class VehicleChecklist extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        props.getReport(
            path[2].replace(/-/g, "_"),
            path[3],
            path[5].replace(/_/g, " ").replace(/\./g, ":")
        );
        this.state = {
            reportRetrieved: false,
            edit: path[1] === "report-view" ? false : true,
            report: []
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }
    gridStyle = length => {
        return {
            display: "grid",
            gridTemplateRows: `repeat(${length - 1}, 35px)`,
            gridTemplateColumns: `repeat(19, 5.48%)`,
            gridGap: "1px",
            backgroundColor: "rgb(4, 71, 107)",
            border: "1px solid rgb(4, 71, 107)",
            marginBottom: "10px"
        };
    };

    cellPosition = (rowIndex, columnIndex, rowEnd, columnEnd) => {
        return {
            gridRowStart: `${rowIndex}`,
            gridRowEnd: `${rowEnd}`,
            gridColumnStart: `${columnIndex}`,
            gridColumnEnd: `${columnEnd}`
        };
    };

    cellStyle = (
        rowIndex,
        columnIndex,
        rowEnd,
        columnEnd,
        fontTrue,
        negative
    ) => {
        let font;
        let bColor = "white";
        let fontColor = "black";
        if (fontTrue) {
            font = `"Handlee", cursive`;
        }
        if (negative) {
            bColor = "rgb(4, 71, 107)";
            fontColor = "white";
        }

        return {
            ...this.cellPosition(rowIndex, columnIndex, rowEnd, columnEnd),
            padding: "10px",
            background: `${bColor}`,
            fontFamily: `${font}`,
            flex: 1,
            display: "flex",
            color: `${fontColor}`
        };
    };
    headerStyle = (rowIndex, columnIndex, rowEnd, columnEnd) => {
        return {
            ...this.cellPosition(rowIndex, columnIndex, rowEnd, columnEnd),
            padding: "4px",
            backgroundColor: "rgb(4, 71, 107)",
            fontFamily: `auto`,
            flex: 1,
            display: "flex",
            color: "white",
            fontSize: "25px"
        };
    };
    renderItem(key, detail, type) {
        if (this.state.edit === false) {
            if (type === "image") {
                return (
                    <img
                        style={{ width: "50%", height: "50%" }}
                        src={detail}
                        alt="signatureurl"
                    />
                );
            }
            return detail ? detail : "N/A";
        } else if (this.state.edit === true && this.state.report !== []) {
            if (type === "text") {
                return (
                    <TextField
                        style={{ width: "90%" }}
                        onChange={event => {
                            const report = { ...this.state.report };
                            report[key] = event.target.value;
                            this.setState({ report });
                        }}
                        value={this.state.report[key]}
                    />
                );
            } else if (type === "yes/no") {
                return (
                    <Select
                        value={this.state.report[key]}
                        onChange={event => {
                            const report = { ...this.state.report };
                            report[key] = event.target.value;
                            this.setState({ report });
                        }}
                    >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                    </Select>
                );
            } else if (type === "image") {
                return (
                    <img
                        style={{ width: "50%", height: "50%" }}
                        src={detail}
                        alt="signatureurl"
                    />
                );
            }
        } else {
            return <Typography variant="body1" />;
        }
    }
    renderSigs(attachedPhotos) {
        let photoRow = 3;
        let photoCell = 1;

        let cstyle = cellStyle;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.signature_name}
                    </div>
                    <div
                        style={cstyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.signature_timestamp}
                    </div>
                    <div
                        style={cstyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true
                                });
                            }}
                            style={{
                                width: "60%",
                                height: "auto",
                                margin: "auto",
                                cursor: "pointer"
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const gStyle = this.gridStyle;
        const cStyle = this.cellStyle;
        const hStyle = this.headerStyle;
        return (
            <Card>
                <CardHeader title={"Vehicle Checklist"} />

                <CardContent>
                    <ReactToPrint
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px"
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    <div ref={el => (this.componentRef = el)}>
                        <div style={gStyle(2)}>
                            <div style={hStyle(1, 1, 1, 19)}>
                                Vehicle Checklist
                            </div>
                            <div style={cStyle(2, 1, 2, 4, false, true)}>
                                User Name
                            </div>
                            <div style={cStyle(2, 4, 2, 9, true, false)}>
                                {this.renderItem(
                                    "user_name",
                                    report.user_name,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(2, 9, 2, 13, false, true)}>
                                User Email
                            </div>
                            <div style={cStyle(2, 13, 2, 19, true, false)}>
                                {this.renderItem(
                                    "user_email",
                                    report.user_email,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 1, 3, 4, false, true)}>
                                Plan ID
                            </div>
                            <div style={cStyle(3, 4, 3, 9, true, false)}>
                                {this.renderItem(
                                    "plan_id",
                                    report.plan_id,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(3, 9, 3, 13, false, true)}>
                                Time
                            </div>
                            <div style={cStyle(3, 13, 3, 19, true, false)}>
                                {this.renderItem(
                                    "timestamp",
                                    report.timestamp,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(4, 1, 4, 4, false, true)}>
                                Contract Number
                            </div>
                            <div style={cStyle(4, 4, 4, 9, true, false)}>
                                {this.renderItem(
                                    "contract_number",
                                    report.contract_number,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(4, 9, 4, 19)} />
                        </div>
                        <div style={gStyle(0)}>
                            <div style={hStyle(1, 1, 1, 5)}>Vehicle ID</div>
                            <div style={cStyle(1, 5, 1, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_reg",
                                    report.vehicle_reg,
                                    "text"
                                )}
                            </div>
                        </div>
                        <div style={gStyle(35)}>
                            <div style={hStyle(1, 1, 1, 19)}>Checklist</div>
                            <div style={cStyle(2, 1, 2, 9, false, true)}>
                                Checks
                            </div>
                            <div style={cStyle(2, 9, 2, 19, false, true)}>
                                Comments
                            </div>

                            <div style={cStyle(3, 1, 3, 7, false, true)}>
                                1. Tyre check and wheel condition
                            </div>
                            <div style={cStyle(3, 7, 3, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_1_yes_or_no",
                                    report.vehicle_checkbox_1_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(3, 8, 3, 10, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(3, 9, 3, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_1_comments",
                                    report.vehicle_1_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(4, 1, 4, 7, false, true)}>
                                2. Brakes/ABS/EBS Warning Light
                            </div>
                            <div style={cStyle(4, 7, 4, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_2_yes_or_no",
                                    report.vehicle_checkbox_2_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(4, 8, 4, 9, false, true)}> </div>
                            <div style={cStyle(4, 9, 4, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_2_comments",
                                    report.vehicle_2_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(5, 1, 5, 7, false, true)}>
                                3. All gauges/instruments working correctly
                            </div>
                            <div style={cStyle(5, 7, 5, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_3_yes_or_no",
                                    report.vehicle_checkbox_2_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(5, 8, 5, 9, false, true)}> </div>
                            <div style={cStyle(5, 9, 5, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_3_comments",
                                    report.vehicle_3_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(6, 1, 6, 7, false, true)}>
                                4. All mirrors clean and OK
                            </div>
                            <div style={cStyle(6, 7, 6, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_4_yes_or_no",
                                    report.vehicle_checkbox_3_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(6, 8, 6, 9, false, true)}> </div>
                            <div style={cStyle(6, 9, 6, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_4_comments",
                                    report.vehicle_4_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(7, 1, 7, 7, false, true)}>
                                5. Wipers and Windscreen washer fluid
                            </div>
                            <div style={cStyle(7, 7, 7, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_5_yes_or_no",
                                    report.vehicle_checkbox_5_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(7, 8, 7, 9, false, true)}> </div>
                            <div style={cStyle(7, 9, 7, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_5_comments",
                                    report.vehicle_5_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(8, 1, 8, 7, false, true)}>
                                6. Windscreen/Cab Glass clear from Obstruction
                            </div>
                            <div style={cStyle(8, 7, 8, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_6_yes_or_no",
                                    report.vehicle_checkbox_6_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(8, 8, 8, 9, false, true)}> </div>
                            <div style={cStyle(8, 9, 8, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_6_comments",
                                    report.vehicle_6_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(9, 1, 9, 7, false, true)}>
                                7. Vehicle cleaned and washed
                            </div>
                            <div style={cStyle(9, 7, 9, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_7_yes_or_no",
                                    report.vehicle_checkbox_7_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(9, 8, 9, 9, false, true)}> </div>
                            <div style={cStyle(9, 9, 9, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_7_comments",
                                    report.vehicle_7_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(10, 1, 10, 7, false, true)}>
                                8. Doors (locking, opening and closing
                                correctly)
                            </div>
                            <div style={cStyle(10, 7, 10, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_8_yes_or_no",
                                    report.vehicle_checkbox_8_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(10, 8, 10, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(10, 9, 10, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_8_comments",
                                    report.vehicle_8_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(11, 1, 11, 7, false, true)}>
                                9. Body Work
                            </div>
                            <div style={cStyle(11, 7, 11, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_9_yes_or_no",
                                    report.vehicle_checkbox_9_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(11, 8, 11, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(11, 9, 11, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_9_comments",
                                    report.vehicle_9_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(12, 1, 12, 7, false, true)}>
                                10. Engine and Clutch
                            </div>
                            <div style={cStyle(12, 7, 12, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_10_yes_or_no",
                                    report.vehicle_checkbox_10_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(12, 8, 12, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(12, 9, 12, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_10_comments",
                                    report.vehicle_10_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(13, 1, 13, 7, false, true)}>
                                11. Equipment Secure
                            </div>
                            <div style={cStyle(13, 7, 13, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_11_yes_or_no",
                                    report.vehicle_checkbox_11_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(13, 8, 13, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(13, 9, 13, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_11_comments",
                                    report.vehicle_11_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(14, 1, 14, 7, false, true)}>
                                12. Vehicle Sitting Square (Not Leaning)
                            </div>
                            <div style={cStyle(14, 7, 14, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_12_yes_or_no",
                                    report.vehicle_checkbox_12_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(14, 8, 14, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(14, 9, 14, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_12_comments",
                                    report.vehicle_12_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(15, 1, 15, 7, false, true)}>
                                13. Hazard and Indicator Lights
                            </div>
                            <div style={cStyle(15, 7, 15, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_13_yes_or_no",
                                    report.vehicle_checkbox_13_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(15, 8, 15, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(15, 9, 15, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_13_comments",
                                    report.vehicle_13_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(16, 1, 16, 7, false, true)}>
                                14. Brake and Reversing Lights
                            </div>
                            <div style={cStyle(16, 7, 16, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_14_yes_or_no",
                                    report.vehicle_checkbox_14_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(16, 8, 16, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(16, 9, 16, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_14_comments",
                                    report.vehicle_14_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(17, 1, 17, 7, false, true)}>
                                15. Engine and Beacon Road Lights/LED's on Front
                            </div>
                            <div style={cStyle(17, 7, 17, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_15_yes_or_no",
                                    report.vehicle_checkbox_15_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(17, 8, 17, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(17, 9, 17, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_15_comments",
                                    report.vehicle_15_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(18, 1, 18, 7, false, true)}>
                                16. Head and Fog Lights
                            </div>
                            <div style={cStyle(18, 7, 18, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_16_yes_or_no",
                                    report.vehicle_checkbox_16_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(18, 8, 18, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(18, 9, 18, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_16_comments",
                                    report.vehicle_16_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(19, 1, 19, 7, false, true)}>
                                17. Number Plate Front and Rear Lights
                            </div>
                            <div style={cStyle(19, 7, 19, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_17_yes_or_no",
                                    report.vehicle_checkbox_17_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(19, 8, 19, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(19, 9, 19, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_17_comments",
                                    report.vehicle_17_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(20, 1, 20, 7, false, true)}>
                                18. Reflective Markings
                            </div>
                            <div style={cStyle(20, 7, 20, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_18_yes_or_no",
                                    report.vehicle_checkbox_18_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(20, 8, 20, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(20, 9, 20, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_18_comments",
                                    report.vehicle_18_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(21, 1, 21, 7, false, true)}>
                                19. Tax/Insurance/NCT Discs
                            </div>
                            <div style={cStyle(21, 7, 21, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_19_yes_or_no",
                                    report.vehicle_checkbox_19_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(21, 8, 21, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(21, 9, 21, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_19_comments",
                                    report.vehicle_19_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(22, 1, 22, 7, false, true)}>
                                20. Engine Oil/Water/Windscreen Washer
                                Reservoirs
                            </div>
                            <div style={cStyle(22, 7, 22, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_20_yes_or_no",
                                    report.vehicle_checkbox_20_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(22, 8, 22, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(22, 9, 22, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_20_comments",
                                    report.vehicle_20_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(23, 1, 23, 7, false, true)}>
                                21. Fuel Level Above 1/2
                            </div>
                            <div style={cStyle(23, 7, 23, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_21_yes_or_no",
                                    report.vehicle_checkbox_21_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(23, 8, 23, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(23, 9, 23, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_21_comments",
                                    report.vehicle_21_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(24, 1, 24, 7, false, true)}>
                                22. Seat Belts and Horns Operating Correctly
                            </div>
                            <div style={cStyle(24, 7, 24, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_22_yes_or_no",
                                    report.vehicle_checkbox_22_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(24, 8, 24, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(24, 9, 24, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_22_comments",
                                    report.vehicle_22_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(25, 1, 25, 7, false, true)}>
                                23. Audible Reversing Signal
                            </div>
                            <div style={cStyle(25, 7, 25, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_23_yes_or_no",
                                    report.vehicle_checkbox_23_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(25, 8, 25, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(25, 9, 25, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_23_comments",
                                    report.vehicle_23_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(26, 1, 26, 7, false, true)}>
                                24. Reversing Camera (If Any)
                            </div>
                            <div style={cStyle(26, 7, 26, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_24_yes_or_no",
                                    report.vehicle_checkbox_24_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(26, 8, 26, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(26, 9, 26, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_24_comments",
                                    report.vehicle_24_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(27, 1, 27, 7, false, true)}>
                                25. Toolbox In and Equipped
                            </div>
                            <div style={cStyle(27, 7, 27, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_25_yes_or_no",
                                    report.vehicle_checkbox_25_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(27, 8, 27, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(27, 9, 27, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_25_comments",
                                    report.vehicle_25_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(28, 1, 28, 7, false, true)}>
                                26. Cones
                            </div>
                            <div style={cStyle(28, 7, 28, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_26_yes_or_no",
                                    report.vehicle_checkbox_26_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(28, 8, 28, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(28, 9, 28, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_26_comments",
                                    report.vehicle_26_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(29, 1, 29, 7, false, true)}>
                                27. Signs (Min. 2 Roadworks Ahead)
                            </div>
                            <div style={cStyle(29, 7, 29, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_27_yes_or_no",
                                    report.vehicle_checkbox_27_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(29, 8, 29, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(29, 9, 29, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_27_comments",
                                    report.vehicle_27_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(30, 1, 30, 7, false, true)}>
                                28. Manhole Pry Bar
                            </div>
                            <div style={cStyle(30, 7, 30, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_28_yes_or_no",
                                    report.vehicle_checkbox_28_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(30, 8, 30, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(30, 9, 30, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_28_comments",
                                    report.vehicle_28_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(31, 1, 31, 7, false, true)}>
                                29. Grease Nipples and Grease Points Reservoir
                            </div>
                            <div style={cStyle(31, 7, 31, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_29_yes_or_no",
                                    report.vehicle_checkbox_29_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(31, 8, 31, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(31, 9, 31, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_29_comments",
                                    report.vehicle_29_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(32, 1, 32, 7, false, true)}>
                                30. Fire Extinguisher
                            </div>
                            <div style={cStyle(32, 7, 32, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_30_yes_or_no",
                                    report.vehicle_checkbox_30_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(32, 8, 32, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(32, 9, 32, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_30_comments",
                                    report.vehicle_30_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(33, 1, 33, 7, false, true)}>
                                31. First Aid Kit
                            </div>
                            <div style={cStyle(33, 7, 33, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_31_yes_or_no",
                                    report.vehicle_checkbox_31_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(33, 8, 33, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(33, 9, 33, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_31_comments",
                                    report.vehicle_31_comments,
                                    "text"
                                )}
                            </div>
                            <div style={cStyle(34, 1, 34, 7, false, true)}>
                                32. Super Structure
                            </div>
                            <div style={cStyle(34, 7, 34, 8, true, false)}>
                                {this.renderItem(
                                    "vehicle_checkbox_32_yes_or_no",
                                    report.vehicle_checkbox_32_yes_or_no,
                                    "yes/no"
                                )}
                            </div>
                            <div style={cStyle(34, 8, 34, 9, false, true)}>
                                {" "}
                            </div>
                            <div style={cStyle(34, 9, 34, 19, true, false)}>
                                {this.renderItem(
                                    "vehicle_32_comments",
                                    report.vehicle_32_comments,
                                    "text"
                                )}
                            </div>
                        </div>

                        <div style={gStyle(2)}>
                            <div style={hStyle(1, 1, 1, 19)}> Notes</div>
                            <div style={cStyle(2, 1, 2, 19, true)}>
                                {this.renderItem("notes", report.notes, "text")}
                            </div>
                        </div>
                        {report.attached_signatures !== null ? (
                            <div style={{ width: "100%" }}>
                                <div
                                    style={gStyle(10, 13)}
                                    ref={ref => (this.infoDiv = ref)}
                                >
                                    <div
                                        style={cStyle(1, 1, 1, 7, false, true)}
                                    >
                                        <b>Signatures:</b>
                                    </div>
                                    {report.attached_signatures &&
                                        this.renderSigs(
                                            report.attached_signatures
                                        )}
                                </div>
                            </div>
                        ) : (
                            <div style={gStyle(6)}>
                                <div style={cStyle(1, 1, 6, 6, false, true)}>
                                    Check Completed By: {report.signature_name}
                                </div>
                                <div style={cStyle(1, 6, 6, 19, false, false)}>
                                    <img
                                        style={{
                                            width: "150px",
                                            height: "150px",
                                            margin: "auto"
                                        }}
                                        src={
                                            report.signature_url ===
                                                undefined ||
                                            report.signature_url === null ||
                                            report.signature_url === ""
                                                ? noSig
                                                : report.signature_url
                                        }
                                        alt="Signature"
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    {this.state.edit && (
                        <div>
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit"
                                )}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.setState({ edit: false });
                                        this.props.submitReport(
                                            this.state.report,
                                            this.props.location.pathname
                                        );
                                    }}
                                >
                                    Submit
                                </Button>
                            </Link>
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view"
                                )}
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        this.setState({
                                            edit: false,
                                            report: this.props.report
                                        });
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Link>
                        </div>
                    )}
                    {!this.state.edit && (
                        <Link
                            to={this.props.location.pathname.replace(
                                "report-view",
                                "report-edit"
                            )}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.setState({ edit: true });
                                }}
                            >
                                Edit
                            </Button>
                        </Link>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectVehicleChecklist(store)
        };
    },
    { getReport, submitReport }
)(VehicleChecklist);
